!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("@eg-maps/core")) : "function" == typeof define && define.amd ? define(["@eg-maps/core"], t) : "object" == typeof exports ? exports.egmapsGoogleMaps = t(require("@eg-maps/core")) : e.egmapsGoogleMaps = t(e["@eg-maps/core"]);
}("undefined" != typeof window ? window : global, function (e) {
  return function () {
    "use strict";

    var t = {
        621: function (t) {
          t.exports = e;
        }
      },
      n = {};
    function i(e) {
      var r = n[e];
      if (void 0 !== r) return r.exports;
      var o = n[e] = {
        exports: {}
      };
      return t[e](o, o.exports, i), o.exports;
    }
    i.d = function (e, t) {
      for (var n in t) i.o(t, n) && !i.o(e, n) && Object.defineProperty(e, n, {
        enumerable: !0,
        get: t[n]
      });
    }, i.g = function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    }(), i.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, i.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var r = {};
    return function () {
      i.r(r);
      var e = {};
      i.r(e), i.d(e, {
        GMaps: function () {
          return ae;
        }
      });
      var t,
        n = i(621),
        o = Object.freeze({
          Linear: Object.freeze({
            None: function (e) {
              return e;
            },
            In: function (e) {
              return this.None(e);
            },
            Out: function (e) {
              return this.None(e);
            },
            InOut: function (e) {
              return this.None(e);
            }
          }),
          Quadratic: Object.freeze({
            In: function (e) {
              return e * e;
            },
            Out: function (e) {
              return e * (2 - e);
            },
            InOut: function (e) {
              return (e *= 2) < 1 ? .5 * e * e : -.5 * (--e * (e - 2) - 1);
            }
          }),
          Cubic: Object.freeze({
            In: function (e) {
              return e * e * e;
            },
            Out: function (e) {
              return --e * e * e + 1;
            },
            InOut: function (e) {
              return (e *= 2) < 1 ? .5 * e * e * e : .5 * ((e -= 2) * e * e + 2);
            }
          }),
          Quartic: Object.freeze({
            In: function (e) {
              return e * e * e * e;
            },
            Out: function (e) {
              return 1 - --e * e * e * e;
            },
            InOut: function (e) {
              return (e *= 2) < 1 ? .5 * e * e * e * e : -.5 * ((e -= 2) * e * e * e - 2);
            }
          }),
          Quintic: Object.freeze({
            In: function (e) {
              return e * e * e * e * e;
            },
            Out: function (e) {
              return --e * e * e * e * e + 1;
            },
            InOut: function (e) {
              return (e *= 2) < 1 ? .5 * e * e * e * e * e : .5 * ((e -= 2) * e * e * e * e + 2);
            }
          }),
          Sinusoidal: Object.freeze({
            In: function (e) {
              return 1 - Math.sin((1 - e) * Math.PI / 2);
            },
            Out: function (e) {
              return Math.sin(e * Math.PI / 2);
            },
            InOut: function (e) {
              return .5 * (1 - Math.sin(Math.PI * (.5 - e)));
            }
          }),
          Exponential: Object.freeze({
            In: function (e) {
              return 0 === e ? 0 : Math.pow(1024, e - 1);
            },
            Out: function (e) {
              return 1 === e ? 1 : 1 - Math.pow(2, -10 * e);
            },
            InOut: function (e) {
              return 0 === e ? 0 : 1 === e ? 1 : (e *= 2) < 1 ? .5 * Math.pow(1024, e - 1) : .5 * (2 - Math.pow(2, -10 * (e - 1)));
            }
          }),
          Circular: Object.freeze({
            In: function (e) {
              return 1 - Math.sqrt(1 - e * e);
            },
            Out: function (e) {
              return Math.sqrt(1 - --e * e);
            },
            InOut: function (e) {
              return (e *= 2) < 1 ? -.5 * (Math.sqrt(1 - e * e) - 1) : .5 * (Math.sqrt(1 - (e -= 2) * e) + 1);
            }
          }),
          Elastic: Object.freeze({
            In: function (e) {
              return 0 === e ? 0 : 1 === e ? 1 : -Math.pow(2, 10 * (e - 1)) * Math.sin(5 * (e - 1.1) * Math.PI);
            },
            Out: function (e) {
              return 0 === e ? 0 : 1 === e ? 1 : Math.pow(2, -10 * e) * Math.sin(5 * (e - .1) * Math.PI) + 1;
            },
            InOut: function (e) {
              return 0 === e ? 0 : 1 === e ? 1 : (e *= 2) < 1 ? -.5 * Math.pow(2, 10 * (e - 1)) * Math.sin(5 * (e - 1.1) * Math.PI) : .5 * Math.pow(2, -10 * (e - 1)) * Math.sin(5 * (e - 1.1) * Math.PI) + 1;
            }
          }),
          Back: Object.freeze({
            In: function (e) {
              var t = 1.70158;
              return 1 === e ? 1 : e * e * ((t + 1) * e - t);
            },
            Out: function (e) {
              var t = 1.70158;
              return 0 === e ? 0 : --e * e * ((t + 1) * e + t) + 1;
            },
            InOut: function (e) {
              var t = 2.5949095;
              return (e *= 2) < 1 ? e * e * ((t + 1) * e - t) * .5 : .5 * ((e -= 2) * e * ((t + 1) * e + t) + 2);
            }
          }),
          Bounce: Object.freeze({
            In: function (e) {
              return 1 - o.Bounce.Out(1 - e);
            },
            Out: function (e) {
              return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + .75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + .9375 : 7.5625 * (e -= 2.625 / 2.75) * e + .984375;
            },
            InOut: function (e) {
              return e < .5 ? .5 * o.Bounce.In(2 * e) : .5 * o.Bounce.Out(2 * e - 1) + .5;
            }
          }),
          generatePow: function (e) {
            return void 0 === e && (e = 4), e = (e = e < Number.EPSILON ? Number.EPSILON : e) > 1e4 ? 1e4 : e, {
              In: function (t) {
                return Math.pow(t, e);
              },
              Out: function (t) {
                return 1 - Math.pow(1 - t, e);
              },
              InOut: function (t) {
                return t < .5 ? Math.pow(2 * t, e) / 2 : (1 - Math.pow(2 - 2 * t, e)) / 2 + .5;
              }
            };
          }
        }),
        a = function () {
          return performance.now();
        },
        s = function () {
          function e() {
            this._tweens = {}, this._tweensAddedDuringUpdate = {};
          }
          return e.prototype.getAll = function () {
            var e = this;
            return Object.keys(this._tweens).map(function (t) {
              return e._tweens[t];
            });
          }, e.prototype.removeAll = function () {
            this._tweens = {};
          }, e.prototype.add = function (e) {
            this._tweens[e.getId()] = e, this._tweensAddedDuringUpdate[e.getId()] = e;
          }, e.prototype.remove = function (e) {
            delete this._tweens[e.getId()], delete this._tweensAddedDuringUpdate[e.getId()];
          }, e.prototype.update = function (e, t) {
            void 0 === e && (e = a()), void 0 === t && (t = !1);
            var n = Object.keys(this._tweens);
            if (0 === n.length) return !1;
            for (; n.length > 0;) {
              this._tweensAddedDuringUpdate = {};
              for (var i = 0; i < n.length; i++) {
                var r = this._tweens[n[i]],
                  o = !t;
                r && !1 === r.update(e, o) && !t && delete this._tweens[n[i]];
              }
              n = Object.keys(this._tweensAddedDuringUpdate);
            }
            return !0;
          }, e;
        }(),
        l = {
          Linear: function (e, t) {
            var n = e.length - 1,
              i = n * t,
              r = Math.floor(i),
              o = l.Utils.Linear;
            return t < 0 ? o(e[0], e[1], i) : t > 1 ? o(e[n], e[n - 1], n - i) : o(e[r], e[r + 1 > n ? n : r + 1], i - r);
          },
          Bezier: function (e, t) {
            for (var n = 0, i = e.length - 1, r = Math.pow, o = l.Utils.Bernstein, a = 0; a <= i; a++) n += r(1 - t, i - a) * r(t, a) * e[a] * o(i, a);
            return n;
          },
          CatmullRom: function (e, t) {
            var n = e.length - 1,
              i = n * t,
              r = Math.floor(i),
              o = l.Utils.CatmullRom;
            return e[0] === e[n] ? (t < 0 && (r = Math.floor(i = n * (1 + t))), o(e[(r - 1 + n) % n], e[r], e[(r + 1) % n], e[(r + 2) % n], i - r)) : t < 0 ? e[0] - (o(e[0], e[0], e[1], e[1], -i) - e[0]) : t > 1 ? e[n] - (o(e[n], e[n], e[n - 1], e[n - 1], i - n) - e[n]) : o(e[r ? r - 1 : 0], e[r], e[n < r + 1 ? n : r + 1], e[n < r + 2 ? n : r + 2], i - r);
          },
          Utils: {
            Linear: function (e, t, n) {
              return (t - e) * n + e;
            },
            Bernstein: function (e, t) {
              var n = l.Utils.Factorial;
              return n(e) / n(t) / n(e - t);
            },
            Factorial: (t = [1], function (e) {
              var n = 1;
              if (t[e]) return t[e];
              for (var i = e; i > 1; i--) n *= i;
              return t[e] = n, n;
            }),
            CatmullRom: function (e, t, n, i, r) {
              var o = .5 * (n - e),
                a = .5 * (i - t),
                s = r * r;
              return (2 * t - 2 * n + o + a) * (r * s) + (-3 * t + 3 * n - 2 * o - a) * s + o * r + t;
            }
          }
        },
        u = function () {
          function e() {}
          return e.nextId = function () {
            return e._nextId++;
          }, e._nextId = 0, e;
        }(),
        c = new s(),
        h = function () {
          function e(e, t) {
            void 0 === t && (t = c), this._object = e, this._group = t, this._isPaused = !1, this._pauseStart = 0, this._valuesStart = {}, this._valuesEnd = {}, this._valuesStartRepeat = {}, this._duration = 1e3, this._isDynamic = !1, this._initialRepeat = 0, this._repeat = 0, this._yoyo = !1, this._isPlaying = !1, this._reversed = !1, this._delayTime = 0, this._startTime = 0, this._easingFunction = o.Linear.None, this._interpolationFunction = l.Linear, this._chainedTweens = [], this._onStartCallbackFired = !1, this._onEveryStartCallbackFired = !1, this._id = u.nextId(), this._isChainStopped = !1, this._propertiesAreSetUp = !1, this._goToEnd = !1;
          }
          return e.prototype.getId = function () {
            return this._id;
          }, e.prototype.isPlaying = function () {
            return this._isPlaying;
          }, e.prototype.isPaused = function () {
            return this._isPaused;
          }, e.prototype.getDuration = function () {
            return this._duration;
          }, e.prototype.to = function (e, t) {
            if (void 0 === t && (t = 1e3), this._isPlaying) throw new Error("Can not call Tween.to() while Tween is already started or paused. Stop the Tween first.");
            return this._valuesEnd = e, this._propertiesAreSetUp = !1, this._duration = t < 0 ? 0 : t, this;
          }, e.prototype.duration = function (e) {
            return void 0 === e && (e = 1e3), this._duration = e < 0 ? 0 : e, this;
          }, e.prototype.dynamic = function (e) {
            return void 0 === e && (e = !1), this._isDynamic = e, this;
          }, e.prototype.start = function (e, t) {
            if (void 0 === e && (e = a()), void 0 === t && (t = !1), this._isPlaying) return this;
            if (this._group && this._group.add(this), this._repeat = this._initialRepeat, this._reversed) for (var n in this._reversed = !1, this._valuesStartRepeat) this._swapEndStartRepeatValues(n), this._valuesStart[n] = this._valuesStartRepeat[n];
            if (this._isPlaying = !0, this._isPaused = !1, this._onStartCallbackFired = !1, this._onEveryStartCallbackFired = !1, this._isChainStopped = !1, this._startTime = e, this._startTime += this._delayTime, !this._propertiesAreSetUp || t) {
              if (this._propertiesAreSetUp = !0, !this._isDynamic) {
                var i = {};
                for (var r in this._valuesEnd) i[r] = this._valuesEnd[r];
                this._valuesEnd = i;
              }
              this._setupProperties(this._object, this._valuesStart, this._valuesEnd, this._valuesStartRepeat, t);
            }
            return this;
          }, e.prototype.startFromCurrentValues = function (e) {
            return this.start(e, !0);
          }, e.prototype._setupProperties = function (e, t, n, i, r) {
            for (var o in n) {
              var a = e[o],
                s = Array.isArray(a),
                l = s ? "array" : typeof a,
                u = !s && Array.isArray(n[o]);
              if ("undefined" !== l && "function" !== l) {
                if (u) {
                  if (0 === (v = n[o]).length) continue;
                  for (var c = [a], h = 0, d = v.length; h < d; h += 1) {
                    var p = this._handleRelativeValue(a, v[h]);
                    if (isNaN(p)) {
                      u = !1, console.warn("Found invalid interpolation list. Skipping.");
                      break;
                    }
                    c.push(p);
                  }
                  u && (n[o] = c);
                }
                if ("object" !== l && !s || !a || u) (void 0 === t[o] || r) && (t[o] = a), s || (t[o] *= 1), i[o] = u ? n[o].slice().reverse() : t[o] || 0;else {
                  t[o] = s ? [] : {};
                  var g = a;
                  for (var f in g) t[o][f] = g[f];
                  i[o] = s ? [] : {};
                  var v = n[o];
                  if (!this._isDynamic) {
                    var m = {};
                    for (var f in v) m[f] = v[f];
                    n[o] = v = m;
                  }
                  this._setupProperties(g, t[o], v, i[o], r);
                }
              }
            }
          }, e.prototype.stop = function () {
            return this._isChainStopped || (this._isChainStopped = !0, this.stopChainedTweens()), this._isPlaying ? (this._group && this._group.remove(this), this._isPlaying = !1, this._isPaused = !1, this._onStopCallback && this._onStopCallback(this._object), this) : this;
          }, e.prototype.end = function () {
            return this._goToEnd = !0, this.update(1 / 0), this;
          }, e.prototype.pause = function (e) {
            return void 0 === e && (e = a()), this._isPaused || !this._isPlaying || (this._isPaused = !0, this._pauseStart = e, this._group && this._group.remove(this)), this;
          }, e.prototype.resume = function (e) {
            return void 0 === e && (e = a()), this._isPaused && this._isPlaying ? (this._isPaused = !1, this._startTime += e - this._pauseStart, this._pauseStart = 0, this._group && this._group.add(this), this) : this;
          }, e.prototype.stopChainedTweens = function () {
            for (var e = 0, t = this._chainedTweens.length; e < t; e++) this._chainedTweens[e].stop();
            return this;
          }, e.prototype.group = function (e) {
            return void 0 === e && (e = c), this._group = e, this;
          }, e.prototype.delay = function (e) {
            return void 0 === e && (e = 0), this._delayTime = e, this;
          }, e.prototype.repeat = function (e) {
            return void 0 === e && (e = 0), this._initialRepeat = e, this._repeat = e, this;
          }, e.prototype.repeatDelay = function (e) {
            return this._repeatDelayTime = e, this;
          }, e.prototype.yoyo = function (e) {
            return void 0 === e && (e = !1), this._yoyo = e, this;
          }, e.prototype.easing = function (e) {
            return void 0 === e && (e = o.Linear.None), this._easingFunction = e, this;
          }, e.prototype.interpolation = function (e) {
            return void 0 === e && (e = l.Linear), this._interpolationFunction = e, this;
          }, e.prototype.chain = function () {
            for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
            return this._chainedTweens = e, this;
          }, e.prototype.onStart = function (e) {
            return this._onStartCallback = e, this;
          }, e.prototype.onEveryStart = function (e) {
            return this._onEveryStartCallback = e, this;
          }, e.prototype.onUpdate = function (e) {
            return this._onUpdateCallback = e, this;
          }, e.prototype.onRepeat = function (e) {
            return this._onRepeatCallback = e, this;
          }, e.prototype.onComplete = function (e) {
            return this._onCompleteCallback = e, this;
          }, e.prototype.onStop = function (e) {
            return this._onStopCallback = e, this;
          }, e.prototype.update = function (e, t) {
            var n,
              i,
              r = this;
            if (void 0 === e && (e = a()), void 0 === t && (t = !0), this._isPaused) return !0;
            var o = this._startTime + this._duration;
            if (!this._goToEnd && !this._isPlaying) {
              if (e > o) return !1;
              t && this.start(e, !0);
            }
            if (this._goToEnd = !1, e < this._startTime) return !0;
            !1 === this._onStartCallbackFired && (this._onStartCallback && this._onStartCallback(this._object), this._onStartCallbackFired = !0), !1 === this._onEveryStartCallbackFired && (this._onEveryStartCallback && this._onEveryStartCallback(this._object), this._onEveryStartCallbackFired = !0);
            var s = e - this._startTime,
              l = this._duration + (null !== (n = this._repeatDelayTime) && void 0 !== n ? n : this._delayTime),
              u = this._duration + this._repeat * l,
              c = function () {
                if (0 === r._duration) return 1;
                if (s > u) return 1;
                var e = Math.trunc(s / l),
                  t = s - e * l,
                  n = Math.min(t / r._duration, 1);
                return 0 === n && s === r._duration ? 1 : n;
              }(),
              h = this._easingFunction(c);
            if (this._updateProperties(this._object, this._valuesStart, this._valuesEnd, h), this._onUpdateCallback && this._onUpdateCallback(this._object, c), 0 === this._duration || s >= this._duration) {
              if (this._repeat > 0) {
                var d = Math.min(Math.trunc((s - this._duration) / l) + 1, this._repeat);
                for (i in isFinite(this._repeat) && (this._repeat -= d), this._valuesStartRepeat) this._yoyo || "string" != typeof this._valuesEnd[i] || (this._valuesStartRepeat[i] = this._valuesStartRepeat[i] + parseFloat(this._valuesEnd[i])), this._yoyo && this._swapEndStartRepeatValues(i), this._valuesStart[i] = this._valuesStartRepeat[i];
                return this._yoyo && (this._reversed = !this._reversed), this._startTime += l * d, this._onRepeatCallback && this._onRepeatCallback(this._object), this._onEveryStartCallbackFired = !1, !0;
              }
              this._onCompleteCallback && this._onCompleteCallback(this._object);
              for (var p = 0, g = this._chainedTweens.length; p < g; p++) this._chainedTweens[p].start(this._startTime + this._duration, !1);
              return this._isPlaying = !1, !1;
            }
            return !0;
          }, e.prototype._updateProperties = function (e, t, n, i) {
            for (var r in n) if (void 0 !== t[r]) {
              var o = t[r] || 0,
                a = n[r],
                s = Array.isArray(e[r]),
                l = Array.isArray(a);
              !s && l ? e[r] = this._interpolationFunction(a, i) : "object" == typeof a && a ? this._updateProperties(e[r], o, a, i) : "number" == typeof (a = this._handleRelativeValue(o, a)) && (e[r] = o + (a - o) * i);
            }
          }, e.prototype._handleRelativeValue = function (e, t) {
            return "string" != typeof t ? t : "+" === t.charAt(0) || "-" === t.charAt(0) ? e + parseFloat(t) : parseFloat(t);
          }, e.prototype._swapEndStartRepeatValues = function (e) {
            var t = this._valuesStartRepeat[e],
              n = this._valuesEnd[e];
            this._valuesStartRepeat[e] = "string" == typeof n ? this._valuesStartRepeat[e] + parseFloat(n) : this._valuesEnd[e], this._valuesEnd[e] = t;
          }, e;
        }(),
        d = (u.nextId, c),
        p = (d.getAll.bind(d), d.removeAll.bind(d), d.add.bind(d), d.remove.bind(d), d.update.bind(d));
      function g(e) {
        return g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, g(e);
      }
      function f(e, t) {
        return function (e) {
          if (Array.isArray(e)) return e;
        }(e) || function (e, t) {
          var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
          if (null != n) {
            var i,
              r,
              o,
              a,
              s = [],
              l = !0,
              u = !1;
            try {
              if (o = (n = n.call(e)).next, 0 === t) {
                if (Object(n) !== n) return;
                l = !1;
              } else for (; !(l = (i = o.call(n)).done) && (s.push(i.value), s.length !== t); l = !0);
            } catch (e) {
              u = !0, r = e;
            } finally {
              try {
                if (!l && null != n.return && (a = n.return(), Object(a) !== a)) return;
              } finally {
                if (u) throw r;
              }
            }
            return s;
          }
        }(e, t) || m(e, t) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function v(e) {
        return function (e) {
          if (Array.isArray(e)) return y(e);
        }(e) || function (e) {
          if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || m(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      function m(e, t) {
        if (e) {
          if ("string" == typeof e) return y(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? y(e, t) : void 0;
        }
      }
      function y(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
        return i;
      }
      function b() {
        return b = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, n) {
          var i = function (e, t) {
            for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = E(e)););
            return e;
          }(e, t);
          if (i) {
            var r = Object.getOwnPropertyDescriptor(i, t);
            return r.get ? r.get.call(arguments.length < 3 ? e : n) : r.value;
          }
        }, b.apply(this, arguments);
      }
      function _(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function k(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, (r = i.key, o = void 0, o = function (e, t) {
            if ("object" !== g(e) || null === e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
              var i = n.call(e, t || "default");
              if ("object" !== g(i)) return i;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
          }(r, "string"), "symbol" === g(o) ? o : String(o)), i);
        }
        var r, o;
      }
      function L(e, t, n) {
        return t && k(e.prototype, t), n && k(e, n), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }
      function C(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && M(e, t);
      }
      function M(e, t) {
        return M = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
          return e.__proto__ = t, e;
        }, M(e, t);
      }
      function P(e) {
        var t = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var n,
            i = E(e);
          if (t) {
            var r = E(this).constructor;
            n = Reflect.construct(i, arguments, r);
          } else n = i.apply(this, arguments);
          return function (e, t) {
            if (t && ("object" === g(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return function (e) {
              if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return e;
            }(e);
          }(this, n);
        };
      }
      function E(e) {
        return E = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, E(e);
      }
      var O = n.Utils.firstDefinedValue,
        w = n.Utils.firstDefinedValueAndKey,
        I = n.Utils.firstDefinedKey,
        T = n.Utils.removeDuplicates,
        S = n.Utils.roundLatOrLng,
        A = n.Utils.roundLatLng,
        x = n.Utils.isArray,
        F = n.Utils.getPaddedZoomAndCenter,
        D = n.Utils.roundZoom,
        j = n.Geo.computeZoomFromBBox,
        U = n.Geo.addMeterToLat,
        z = n.Geo.convertGeoJsonPolygonToPath,
        B = n.MarkerUtils.setAccessibilityFields,
        Z = n.MarkerUtils.createCornerIcons,
        R = n.MarkerUtils.createInnerIcons,
        H = n.MarkerUtils.createDoubleClickEventCanceller,
        N = n.MarkerUtils.createImageIcon,
        V = n.MarkerUtils.createBasicTextMarker,
        K = n.Labels.createLabels,
        W = 256,
        G = 256,
        q = function (e) {
          C(n, e);
          var t = P(n);
          function n(e, i, r, o, a, s) {
            var l;
            return _(this, n), (l = t.call(this, e, i, r, o, a, s, 0)).tileSize = new google.maps.Size(W, G), l.debugTileId = e.tiles.debugTileId, l;
          }
          return L(n, [{
            key: "getTile",
            value: function (e, t, n) {
              var i = this;
              if (setTimeout(function () {
                return i.loadTile(e.x, e.y, t);
              }, 10), this.debugTileId) {
                var r = n.createElement("div");
                return r.innerHTML = String(e), r.style.width = this.tileSize.width + "px", r.style.height = this.tileSize.height + "px", r.style.fontSize = "10", r.style.borderStyle = "solid", r.style.borderWidth = "1px", r.style.borderColor = "#AAAAAA", r;
              }
            }
          }, {
            key: "unbindAll",
            value: function () {
              this.getPanes().overlayMouseTarget.removeAllChildren();
            }
          }]), n;
        }(n.TilesLoader),
        X = "click",
        Q = "click",
        J = "mouseenter",
        $ = "mouseleave",
        Y = "focus",
        ee = "focusout",
        te = "keydown",
        ne = "keyup",
        ie = "keypress",
        re = {
          mapDragStart: "dragstart",
          mapDragEnd: "dragend",
          mapCenterChanged: "center_changed",
          mapBoundsChanged: "bounds_changed",
          mapZoomChanged: "zoom_changed",
          tilesLoaded: "tilesloaded",
          idle: "idle",
          mapTypeIdChanged: "maptypeid_changed"
        },
        oe = "marker-icon",
        ae = function (e) {
          C(i, e);
          var t = P(i);
          function i(e, n, r, o) {
            var a;
            return _(this, i), (a = t.call(this, e, n, r, o)).logger = e.logger("GMaps"), a.logger.debug("GMaps constructor"), a.mapFocusListenersToRegister = [], a.visiblePolygonsByKey = new Map(), a.realmap = void 0, a.keyboardListeners = void 0, a;
          }
          return L(i, [{
            key: "_buildMapProviderOptions",
            value: function (e, t) {
              var n,
                i = {
                  keyboardShortcuts: !1
                };
              return null !== (n = this.settings.googleMaps) && void 0 !== n && n.gmapsAddConfig && Object.assign(i, this.settings.googleMaps.gmapsAddConfig), e && t && (i.zoom = e, i.center = {
                lat: t[0],
                lng: t[1]
              }), i;
            }
          }, {
            key: "updateMapProviderConfig",
            value: function () {
              var e = this._buildMapProviderOptions(this.realmap.getZoom(), this.getCenter());
              this.realmap.setOptions(e);
            }
          }, {
            key: "removeMarkerFromMap",
            value: function (e) {
              n.HtmlUtils.detachElement(e), e.debug && e.debug.setMap(null), this.clearObfuscateAreaFromMarker(e), this.cleanMarkerListeners(e);
            }
          }, {
            key: "cleanMarkerListeners",
            value: function (e) {
              var t;
              null === (t = e.clean) || void 0 === t || t.forEach(function (e) {
                return e();
              }), e.clean = [];
            }
          }, {
            key: "cloneMarker",
            value: function (e) {
              return null == e ? void 0 : e.clone();
            }
          }, {
            key: "_callbackWhenElementReattached",
            value: function () {
              var e = this;
              return new Promise(function (t) {
                setTimeout(function () {
                  var n = e.temporaryDiv;
                  e.temporaryDiv = void 0, e._reattachElementFromTemporaryDiv(n, e.customMarkerOverlay.getPanes().overlayMouseTarget), e._updateViewport(), t();
                }, 20);
              });
            }
          }, {
            key: "init",
            value: function (e, t) {
              var i = this,
                r = this.addEventListener.bind(this),
                o = this._zoomAndCenterFromViewport(e, t) || {},
                a = o.zoom,
                s = o.center,
                l = this._buildMapProviderOptions(a, s);
              this.node && (this.realmap = new google.maps.Map(this.node, l)), this._initializeTilesOverlayMapType(), n.HtmlUtils.documentIsDefined() && (this.temporaryDiv = n.HtmlUtils.createDiv(this.uniqId("temporaryDiv")));
              var u = this._createPopup.bind(this),
                c = this._registerKeyboardListeners.bind(this),
                h = this._registerListenersMap.bind(this),
                d = this._registerMapFocusListeners.bind(this),
                p = this._registerTilesLoadedListener.bind(this),
                g = this._updateViewport.bind(this);
              return this._initializeCustomMarkerOverlay(this.temporaryDiv, this._callbackWhenElementReattached.bind(this)).then(function () {
                i.mapNavFocusElement = i._findMapFocusElement(), i.mapNavFocusElement && (n.HtmlUtils.setTabIndex(i.mapNavFocusElement, 0), i.mapFocusListenersToRegister.forEach(function (e) {
                  var t = e.eventName,
                    n = e.cb;
                  i.listenersToDeregister.push(r(i.mapNavFocusElement, t, n));
                })), i.popup = u(), c(), h(), d(), p(), g();
              }), this.configHelper.readParam("map,mapInitWaitForTiles") ? new Promise(function (e) {
                return r(i.realmap, re.tilesLoaded, e, !0);
              }) : Promise.resolve();
            }
          }, {
            key: "_findMapFocusElement",
            value: function () {
              if (this.node) return n.HtmlUtils.childrenAsArray(this.node).map(function (e) {
                return n.HtmlUtils.getFirstChildWithAriaRoleDescription(e, "map", !0);
              }).filter(function (e) {
                return void 0 !== e;
              })[0];
            }
          }, {
            key: "registerListenerOnMapFocusElement",
            value: function (e, t) {
              this.mapNavFocusElement ? this.listenersToDeregister.push(this.addEventListener(this.mapNavFocusElement, e, t)) : this.mapFocusListenersToRegister.push({
                eventName: e,
                cb: t
              });
            }
          }, {
            key: "_registerMapFocusListeners",
            value: function () {
              var e = this;
              if (this.keyboardFeatures && this.mapNavFocusElement) {
                this.listenersToDeregister.push(this.addEventListener(this.mapNavFocusElement, Y, function () {
                  return e.keyboardFeatures.refreshKeyboardNavIconVisibility();
                }));
                this.listenersToDeregister.push(this.addEventListener(this.mapNavFocusElement, ee, function () {
                  return e.keyboardFeatures.refreshKeyboardNavIconVisibility(!1);
                }));
              }
            }
          }, {
            key: "_registerTilesLoadedListener",
            value: function () {
              var e = this;
              this.listenersToDeregister.push(this.addEventListener(this.realmap, re.tilesLoaded, function () {
                return e.handleTilesLoaded("mapProvider", "map");
              }));
            }
          }, {
            key: "_initializeTilesOverlayMapType",
            value: function () {
              var e;
              this.tilesLoader = new q(this.settings, this.createTileFeature.bind(this), this.removeTileFeature.bind(this), this._updateViewport.bind(this), this.handleTilesLoaded.bind(this), this.handleTilesContentLoaded.bind(this)), null === (e = this.realmap) || void 0 === e || null === (e = e.overlayMapTypes) || void 0 === e || e.insertAt(0, this.tilesLoader);
            }
          }, {
            key: "_reattachElementFromTemporaryDiv",
            value: function (e, t) {
              if (e) for (var i = e.children, r = 0; r < ((null == i ? void 0 : i.length) || -1); r++) n.HtmlUtils.reattachElement(i[r], t);
            }
          }, {
            key: "_initializeCustomMarkerOverlay",
            value: function (e, t) {
              var i = this,
                r = this._updateMarkerPosition.bind(this),
                o = this.features.all.bind(this),
                a = function (i, r, o, a, s) {
                  this.updateTextMarkerPosition = r, this.listAllFeatures = o, this.onAdd = function () {
                    var i = this.getPanes().overlayMouseTarget;
                    a(e), n.HtmlUtils.setZIndex(i, google.maps.Marker.MAX_ZINDEX + 1), t(), s();
                  }, this.setMap(i), this.onRemove = function () {
                    this.listAllFeatures().forEach(function (e) {
                      n.HtmlUtils.detachElement(e.popup);
                    });
                    var e,
                      t = function (e, t) {
                        var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (!n) {
                          if (Array.isArray(e) || (n = m(e)) || t && e && "number" == typeof e.length) {
                            n && (e = n);
                            var i = 0,
                              r = function () {};
                            return {
                              s: r,
                              n: function () {
                                return i >= e.length ? {
                                  done: !0
                                } : {
                                  done: !1,
                                  value: e[i++]
                                };
                              },
                              e: function (e) {
                                throw e;
                              },
                              f: r
                            };
                          }
                          throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }
                        var o,
                          a = !0,
                          s = !1;
                        return {
                          s: function () {
                            n = n.call(e);
                          },
                          n: function () {
                            var e = n.next();
                            return a = e.done, e;
                          },
                          e: function (e) {
                            s = !0, o = e;
                          },
                          f: function () {
                            try {
                              a || null == n.return || n.return();
                            } finally {
                              if (s) throw o;
                            }
                          }
                        };
                      }(this.clusters);
                    try {
                      for (t.s(); !(e = t.n()).done;) {
                        var i = e.value;
                        n.HtmlUtils.detachElement(i.marker);
                      }
                    } catch (e) {
                      t.e(e);
                    } finally {
                      t.f();
                    }
                  }, this.draw = function () {
                    this.updateTextMarkerPosition();
                  };
                };
              return a.prototype = new google.maps.OverlayView(), new Promise(function (e) {
                i.customMarkerOverlay = new a(i.realmap, r, o, i._reattachElementFromTemporaryDiv.bind(i), e);
              });
            }
          }, {
            key: "getMarkerComponent",
            value: function (e) {
              return e.marker;
            }
          }, {
            key: "moveMarkerPosition",
            value: function (e, t) {
              var n = this.customMarkerOverlay.getProjection(),
                i = n.fromLatLngToDivPixel(new google.maps.LatLng(e.latLng[0], e.latLng[1])),
                r = {
                  x: i.x + t.x,
                  y: i.y + t.y
                },
                o = n.fromDivPixelToLatLng(r);
              e.latLng[0] = o.lat(), e.latLng[1] = o.lng(), e.computedLatLng = [o.lat(), o.lng()], this.getMarkerComponent(e).position = o, this._updateMarkerPositionOnLayer(e, n);
            }
          }, {
            key: "_updateViewport",
            value: function (e) {
              var t,
                n = this;
              return null !== (t = this.customMarkerOverlay) && void 0 !== t && null !== (t = t.getPanes()) && void 0 !== t && t.overlayMouseTarget ? b(E(i.prototype), "_updateViewport", this).call(this, e).then(function (e) {
                return n._updateMarkerPosition(), e;
              }) : Promise.resolve(e);
            }
          }, {
            key: "getRectOfMarker",
            value: function (e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                i = this.customMarkerOverlay.getProjection(),
                r = e.computedLatLng && e.computedLatLng[0] ? e.computedLatLng[0] : e.latLng[0],
                o = e.computedLatLng && e.computedLatLng[1] ? e.computedLatLng[1] : e.latLng[1],
                a = i.fromLatLngToDivPixel(new google.maps.LatLng(r, o)),
                s = this.getMarkerComponent(e),
                l = s.clientWidth,
                u = s.clientHeight;
              return n.HtmlUtils.getRect(a, l + 2 * t, u + 2 * t);
            }
          }, {
            key: "_updateMarkerPosition",
            value: function (e) {
              var t = this;
              if (this.customMarkerOverlay) {
                var n = this.customMarkerOverlay.getProjection();
                if (n) {
                  var r = e ? e.filter(function (e) {
                    return t.getMarkerComponent(e);
                  }) : this.features.all().filter(function (e) {
                    return t.getMarkerComponent(e);
                  }).concat(this.clusters || []);
                  if (this.settings.isAtLeastOnePropertyStatusUsingObfuscateMarker || this.settings.isAtLeastOneProductStatusUsingObfuscateMarker) {
                    var o = this.getCenter();
                    Object.values(this.settings.obfuscateRadiusInMeters).forEach(function (e) {
                      var i = [S(U(o[0], 2 * e.radius)), o[1]];
                      e.width = Math.round(t._fromLatLngToDivPixel.apply(t, [n].concat(v(o))).y - t._fromLatLngToDivPixel.apply(t, [n].concat(i)).y);
                    });
                  }
                  r.forEach(function (e) {
                    return t._updateMarkerPositionOnLayer(e, n);
                  }), b(E(i.prototype), "_updateMarkerPosition", this).call(this, r), this.updatePopupPositionOnLayer();
                }
              }
            }
          }, {
            key: "_updateMarkerPositionOnLayer",
            value: function (e, t) {
              if (e && this.getMarkerComponent(e) && t) {
                var i = t.fromLatLngToDivPixel(this.getMarkerComponent(e).position);
                if (i) {
                  var r = "middle";
                  switch (e.markerType) {
                    case "pin":
                    case "price":
                    case "text":
                      r = "bottom";
                  }
                  n.HtmlUtils.setPosition(this.getMarkerComponent(e), i.x + 0, i.y + 0, r);
                }
              }
            }
          }, {
            key: "_fromLatLngToDivPixel",
            value: function (e, t, n) {
              return null == e ? void 0 : e.fromLatLngToDivPixel(new google.maps.LatLng(t, n));
            }
          }, {
            key: "_fromDivPixelToLatLng",
            value: function (e, t, n) {
              return null == e ? void 0 : e.fromDivPixelToLatLng(new google.maps.Point(t, n));
            }
          }, {
            key: "updatePopupPositionOnLayer",
            value: function () {
              var e,
                t = (this.popup || {}).feature;
              if (null !== (e = this.customMarkerOverlay) && void 0 !== e && e.getProjection() && t && t.defined) {
                var i,
                  r,
                  o,
                  a = this._fromLatLngToDivPixel.apply(this, [this.customMarkerOverlay.getProjection()].concat(v(t.latLng)));
                switch (O(this.settings.popupPositions[t.type], t.hashKeys)) {
                  case "above":
                  default:
                    i = 0, r = -2, o = "bottom";
                    break;
                  case "below":
                    i = 0, r = 2, o = "top";
                }
                a && n.HtmlUtils.setPosition(this.popup, a.x + i, a.y + r, o);
              }
            }
          }, {
            key: "ensurePopupVisibility",
            value: function () {
              var e = this.popup,
                t = e.feature,
                n = e.offsetWidth,
                i = e.offsetHeight,
                r = this.node,
                o = r.offsetWidth,
                a = r.offsetHeight,
                s = O(this.configHelper.popupVisibilityPaddings()[t.type], t.hashKeys),
                l = null == s ? void 0 : s.x,
                u = null == s ? void 0 : s.y,
                c = "below" === O(this.settings.popupPositions[t.type], t.hashKeys),
                h = c ? 1 : -1,
                d = this.getRectOfMarker(t).height,
                p = this._fromLatLngToDivPixel.apply(this, [this.customMarkerOverlay.getProjection()].concat(v(t.latLng))),
                g = {
                  x: p.x + o / 2 - n / 2,
                  y: p.y + d * h + a / 2 + i * h
                },
                m = f(this._calculatePopupVisibilityOffsetValues(g, l, u, o, a, n, i, c), 2),
                y = m[0],
                b = m[1];
              0 === y && 0 === b || this.realmap.panBy(y, b);
            }
          }, {
            key: "_registerListenersMap",
            value: function () {
              var e,
                t,
                i,
                r = this;
              this.lastCenterChecked = {
                centers: [this.getCenter()],
                events: []
              }, this.lastZoomValueChecked = [this.getZoom()], (e = this.listenersToDeregister).push.apply(e, v(this._registerListenerForIdle())), this.listenersToDeregister.push(this._registerDragEndEventLogic()), (t = this.listenersToDeregister).push.apply(t, v(this._registerZoomListener())), (i = this.listenersToDeregister).push.apply(i, v(this._registerCenterChangedEventLogic())), this.listenersToDeregister.push(this.addEventListener(this.realmap, re.mapDragStart, this.handleDragStart.bind(this))), this.listenersToDeregister.push(this.addEventListener(this.node, Q, this.handleMapClick.bind(this)));
              this.listenersToDeregister.push(this.addEventListener(this.realmap, re.mapTypeIdChanged, function () {
                r.eventsManager.pushEvent(n.EventTypes.mapTypeChanged, {
                  mapTypeId: r.realmap.getMapTypeId()
                });
              }.bind(this)));
            }
          }, {
            key: "_registerListenerForIdle",
            value: function () {
              this.idle = !0;
              var e = this;
              return [this.addEventListener(this.realmap, re.idle, function () {
                e.idle = !0, e.eventsManager.pushEvent(n.EventTypes.idle);
              }), this.addEventListener(this.realmap, re.mapBoundsChanged, function () {
                return e.idle = !1;
              })];
            }
          }, {
            key: "_registerKeyboardListeners",
            value: function () {
              var e = this,
                t = this.getZoom.bind(this);
              this.keyboardListeners = new n.KeyboardListeners(function (t) {
                var n;
                return (n = e.realmap).panBy.apply(n, v(t));
              }, function () {
                return e.realmap.setZoom(t() + 1);
              }, function () {
                return e.realmap.setZoom(t() - 1);
              }), this.registerListenerOnMapFocusElement(te, this.keyboardListeners.keyDownListenerCallback), this.registerListenerOnMapFocusElement(ne, this.keyboardListeners.keyUpListenerCallback), this.registerListenerOnMapFocusElement(ie, this.keyboardListeners.keyPressListenerCallback);
            }
          }, {
            key: "_registerDragEndEventLogic",
            value: function () {
              var e = this;
              return this.addEventListener(this.realmap, re.mapDragEnd, function () {
                e.lastCenterChecked.events.push("drag");
              });
            }
          }, {
            key: "_registerCenterChangedEventLogic",
            value: function () {
              var e = this,
                t = this.settings.googleMaps.debouncingEventsTime.centerChanged;
              return [this.addEventListener(this.realmap, re.mapCenterChanged, function () {
                e.boundChangedDisabled ? e.lastCenterChecked.centers = [e.getCenter()] : e.lastCenterChecked.centers[1] = e.getCenter();
              }), this.addEventListener(this.realmap, re.idle, function () {
                if (e.lastCenterChecked.centers.length > 1) {
                  var n = f(e.getCenter(), 2),
                    i = n[0],
                    r = n[1],
                    o = e.handleBoundsChanged.bind(e);
                  setTimeout(function () {
                    var t = e.getCenter(),
                      n = f(t, 2),
                      a = n[0],
                      s = n[1];
                    if (a === i && s === r) {
                      e.lastCenterChecked.centers = [t];
                      var l = e.lastCenterChecked.events.splice(0, e.lastCenterChecked.events.length),
                        u = e.keyboardListeners.extractKeyboardEvent("center_changed");
                      T(u).forEach(o), T(l).forEach(o);
                    }
                  }, t);
                }
              })];
            }
          }, {
            key: "_registerZoomListener",
            value: function () {
              var e = this,
                t = this.settings.googleMaps.debouncingEventsTime.zoomChanged;
              return [this.addEventListener(this.realmap, re.mapZoomChanged, function () {
                e.boundChangedDisabled ? e.lastZoomValueChecked = [e.getZoom()] : e.lastZoomValueChecked[1] = e.getZoom();
              }), this.addEventListener(this.realmap, re.idle, function () {
                if (e.lastZoomValueChecked.length > 1) {
                  var n = e.getZoom(),
                    i = e.handleBoundsChanged.bind(e);
                  setTimeout(function () {
                    var t = e.getZoom();
                    if (t === n) {
                      var r = t > f(e.lastZoomValueChecked, 1)[0];
                      e.lastZoomValueChecked = [t];
                      var o = e.keyboardListeners.extractKeyboardEvent("zoom_changed");
                      o.length > 0 ? T(o).forEach(i) : r ? e.handleBoundsChanged("zoomIn") : e.handleBoundsChanged("zoomOut");
                    }
                  }, t);
                }
              })];
            }
          }, {
            key: "_createCallbackForBoundsChanged",
            value: function (e) {
              var t = this.handleBoundsChanged.bind(this);
              return function () {
                return t(e);
              };
            }
          }, {
            key: "centerAndZoomMap",
            value: function (e, t, n) {
              var i = f(e ? A(e) : [], 2),
                r = i[0],
                o = i[1],
                a = t ? D(t) : void 0;
              if (void 0 !== r && void 0 !== o && void 0 !== a && void 0 !== n) {
                var s = this._parseClientPadding(n),
                  l = this._getPaddedZoomAndCenterForCenterAndZoom(e, a, s) || {},
                  u = l.zoom,
                  c = l.center;
                if (void 0 !== u && void 0 !== c) {
                  var h = f(c, 2);
                  r = h[0], o = h[1], a = u;
                }
              }
              var d = this.realmap.getCenter(),
                p = f(A([d.lat(), d.lng()]) || [], 2),
                g = p[0],
                v = p[1],
                m = void 0 !== r && void 0 !== o && (g !== r || v !== o) || void 0 !== a && this.getZoom() !== a;
              return m && this._fitViewport(a, [r, o], !1).then(this._updateViewport.bind(this)), m;
            }
          }, {
            key: "isFeatureInRealBound",
            value: function (e, t) {
              return null == e ? void 0 : e.contains({
                lat: t.latLng[0],
                lng: t.latLng[1]
              });
            }
          }, {
            key: "asNativeBounds",
            value: function (e, t) {
              var n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
              return new google.maps.LatLngBounds(new google.maps.LatLng(S(e[0]), S(e[1], void 0, n)), new google.maps.LatLng(S(t[0]), S(t[1], void 0, n)));
            }
          }, {
            key: "getCenter",
            value: function () {
              var e = this.realmap.getCenter();
              return [S(e.lat()), S(e.lng())];
            }
          }, {
            key: "getZoom",
            value: function () {
              return D(this.realmap.getZoom());
            }
          }, {
            key: "unbindAll",
            value: function () {
              this.listenersToDeregister.forEach(function (e) {
                return e();
              }), this.customMarkerOverlay && this.customMarkerOverlay.unbindAll(), this.realmap.unbindAll();
            }
          }, {
            key: "asBounds",
            value: function (e) {
              if (e) {
                var t = e.getSouthWest(),
                  n = e.getNorthEast(),
                  i = this.getCenter();
                return {
                  sw: [S(t.lat()), S(t.lng())],
                  ne: [S(n.lat()), S(n.lng())],
                  center: i
                };
              }
            }
          }, {
            key: "containerBounds",
            value: function (e) {
              if (this.customMarkerOverlay) {
                var t = this.customMarkerOverlay.getProjection();
                if (t) {
                  var n = t.fromContainerPixelToLatLng(new google.maps.Point(e.offsetLeft - e.offsetWidth / 2, e.offsetTop + e.offsetHeight / 2)),
                    i = t.fromContainerPixelToLatLng(new google.maps.Point(e.offsetLeft + e.offsetWidth / 2, e.offsetTop - e.offsetHeight / 2));
                  return {
                    sw: [S(n.lat()), S(n.lng())],
                    ne: [S(i.lat()), S(i.lng())],
                    center: [S(n.lat() + (n.lat() - i.lat()) / 2), S(i.lng() + (i.lng() - n.lng()) / 2)]
                  };
                }
              }
            }
          }, {
            key: "_boundsForOneCoordinate",
            value: function (e) {
              return e.getNorthEast().equals(e.getSouthWest());
            }
          }, {
            key: "_extendsOneCoordinateBounds",
            value: function (e) {
              var t = new google.maps.LatLng(e.getNorthEast().lat() + .01, e.getNorthEast().lng() + .01),
                n = new google.maps.LatLng(e.getNorthEast().lat() - .01, e.getNorthEast().lng() - .01);
              e.extend(t), e.extend(n);
            }
          }, {
            key: "computeNativeBoundsFromLatLongs",
            value: function (e) {
              if (e.length > 0) {
                var t = new google.maps.LatLngBounds();
                return e.forEach(function (e) {
                  var n = f(A(e), 2),
                    i = n[0],
                    r = n[1];
                  t.extend(new google.maps.LatLng(i, r));
                }), t;
              }
            }
          }, {
            key: "fitLatLongs",
            value: function (e) {
              var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                n = arguments.length > 2 ? arguments[2] : void 0;
              if (this.realmap) {
                var i = this._parseClientPadding(n),
                  r = this._getPaddedZoomAndCenterFromLatLongs(e, t, i) || {},
                  o = r.zoom,
                  a = r.center;
                if (void 0 !== o && void 0 !== a) {
                  var s = this._updateViewport.bind(this),
                    l = this.asBounds.bind(this);
                  return this._fitViewport(o, a).then(s).then(l);
                }
                return Promise.resolve(this.getBounds());
              }
              return Promise.reject("map is not ready");
            }
          }, {
            key: "nativeBounds",
            value: function () {
              var e, t;
              return (null === (e = this.customMarkerOverlay) || void 0 === e || null === (e = e.getProjection()) || void 0 === e || null === (e = e.getVisibleRegion()) || void 0 === e ? void 0 : e.latLngBounds) || (null === (t = this.realmap) || void 0 === t ? void 0 : t.getBounds());
            }
          }, {
            key: "switchMarkerType",
            value: function (e, t) {
              b(E(i.prototype), "switchMarkerType", this).call(this, e, t) && this.customMarkerOverlay && this._updateMarkerPositionOnLayer(e, this.customMarkerOverlay.getProjection());
            }
          }, {
            key: "onMarkerIconsChanged",
            value: function (e) {
              this._updateMarkerPositionOnLayer(e, this.customMarkerOverlay.getProjection());
            }
          }, {
            key: "_fitViewport",
            value: function (e, t) {
              var i = this;
              if (void 0 !== e || t) {
                var r = this.settings.googleMaps.fitBoundsAnimTime || 500,
                  a = f(this.getCenter(), 2),
                  s = a[0],
                  l = a[1],
                  u = {
                    tilt: 0,
                    heading: 0,
                    zoom: this.getZoom(),
                    center: {
                      lat: s,
                      lng: l
                    }
                  },
                  c = f(t, 2),
                  d = c[0],
                  g = c[1],
                  v = {
                    zoom: e,
                    center: {
                      lat: d,
                      lng: g
                    }
                  },
                  m = this;
                n.Geo.areLongitudesCrossingDateLine([l, g]) && (l < 0 ? u.center.lng += 360 : u.center.lng -= 360);
                var y = this.addEventListener.bind(this),
                  b = function () {
                    return new Promise(function (e) {
                      new h(u).to(v, r).easing(o.Exponential.Out).onUpdate(function () {
                        var e = u;
                        u.center.lng < -180 ? e = {
                          zoom: u.zoom,
                          center: {
                            lat: u.center.lat,
                            lng: u.center.lng + 360
                          }
                        } : u.center.lng > 180 && (e = {
                          zoom: u.zoom,
                          center: {
                            lat: u.center.lat,
                            lng: u.center.lng - 360
                          }
                        }), m.boundChangedDisabled = !0, m.realmap.moveCamera(e);
                      }).onComplete(function () {
                        y(m.realmap, re.idle, function () {
                          m.boundChangedDisabled = !1, e();
                        }, !0);
                      }).start(), requestAnimationFrame(function e(t) {
                        requestAnimationFrame(e), p(t);
                      });
                    });
                  };
                return this.idle ? b() : new Promise(function (e) {
                  return y(i.realmap, re.idle, function () {
                    return b().then(e);
                  }, !0);
                });
              }
              return Promise.resolve();
            }
          }, {
            key: "_zoomAndCenterFromViewport",
            value: function (e, t) {
              if (e) {
                var n = e.center,
                  i = e.zoom,
                  r = e.sw,
                  o = e.ne,
                  a = e.coordinates,
                  s = e.useBoundsComputation,
                  l = e.options,
                  u = this._parseClientPadding(t);
                if (n && i) return this._getPaddedZoomAndCenterForCenterAndZoom(n, i, u);
                if (r && o) {
                  var c = A(r),
                    h = A(o);
                  return this._getPaddedZoomAndCenterForBounds(c, h, !1, u);
                }
                if (a && s) {
                  var d = this._computeNativeBounds(a, s, l),
                    p = this._computeZoomAndCenterFromGmapsBounds(d, !1, u) || {},
                    g = p.zoom,
                    f = p.center;
                  if (g && f) return F(g, f, u);
                } else if (x(e) && e.length > 0) return this._getPaddedZoomAndCenterFromLatLongs(e, !0, u);
              }
            }
          }, {
            key: "_getPaddedZoomAndCenterForCenterAndZoom",
            value: function (e, t, n) {
              return F(t, e, n);
            }
          }, {
            key: "_getPaddedZoomAndCenterForBounds",
            value: function (e, t, n, i) {
              var r = new google.maps.LatLngBounds(new google.maps.LatLng(e[0], e[1]), new google.maps.LatLng(t[0], t[1])),
                o = this._computeZoomAndCenterFromGmapsBounds(r, n, i) || {},
                a = o.zoom,
                s = o.center;
              if (a && s) return F(a, s, i);
            }
          }, {
            key: "_getPaddedZoomAndCenterFromLatLongs",
            value: function (e, t, n) {
              var i = this._computeZoomAndCenterFromGmapsBounds(this.computeNativeBoundsFromLatLongs(this.boundsComputation.computeBoundingBox(e)), t, n) || {},
                r = i.zoom,
                o = i.center;
              if (r && o) return F(r, o, n);
            }
          }, {
            key: "_computeZoomAndCenterFromGmapsBounds",
            value: function (e) {
              var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                n = arguments.length > 2 ? arguments[2] : void 0,
                i = e;
              this._boundsForOneCoordinate(i) && (i = new google.maps.LatLngBounds(i.getSouthWest(), i.getNorthEast()), this._extendsOneCoordinateBounds(i));
              var r = j(this.node, i.getSouthWest().lat(), i.getSouthWest().lng(), i.getNorthEast().lat(), i.getNorthEast().lng(), {
                zoomMax: 21,
                padding: t ? this.settings.googleMaps.padding : 0,
                parsedClientPadding: n
              });
              if (isFinite(r)) return {
                zoom: r,
                center: A([i.getCenter().lat(), i.getCenter().lng()])
              };
            }
          }, {
            key: "getTileDim",
            value: function () {
              return {
                width: W,
                height: G
              };
            }
          }, {
            key: "fitBounds",
            value: function (e, t) {
              var n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
                i = arguments.length > 3 ? arguments[3] : void 0;
              if (this.realmap) {
                var r = this._parseClientPadding(i),
                  o = A(e),
                  a = A(t),
                  s = this._getPaddedZoomAndCenterForBounds(o, a, n, r) || {},
                  l = s.zoom,
                  u = s.center;
                if (void 0 !== l && void 0 !== u) {
                  var c = this.getZoom(),
                    h = f(this.getCenter(), 2),
                    d = h[0],
                    p = h[1];
                  if (d !== u[0] || p !== u[1] || c !== l) {
                    var g = this._updateViewport.bind(this),
                      v = this.asBounds.bind(this);
                    return this._fitViewport(l, u).then(g).then(v);
                  }
                }
                return Promise.resolve(this.getBounds());
              }
              return Promise.reject("map is not ready");
            }
          }, {
            key: "addEventListener",
            value: function (e, t, n) {
              var i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
              return e instanceof google.maps.Polygon || Object.values(re).includes(t) ? this._addGoogleMapsEventListener(e, t, n, i) : this._addEventListener(e, t, n, i);
            }
          }, {
            key: "_addEventListener",
            value: function (e, t, n) {
              return arguments.length > 3 && void 0 !== arguments[3] && arguments[3] ? e.addEventListenerOnce(t, n) : e.addEventListener(t, n), function () {
                return e.removeEventListener(t, n);
              };
            }
          }, {
            key: "_addGoogleMapsEventListener",
            value: function (e, t, n) {
              var i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3] ? google.maps.event.addListenerOnce(e, t, n) : google.maps.event.addListener(e, t, n);
              return function () {
                return google.maps.event.removeListener(i);
              };
            }
          }, {
            key: "_createPopup",
            value: function () {
              var e = this._createGenericPopup(this._getMainParent());
              return n.HtmlUtils.setZIndex(e, this.settings.maxZIndex + 1), n.HtmlUtils.setDisplayNone(e), e.visibleElement = e, e.cssElement = e, e.listening = e, e.clean = [].concat(v(this.registerCompListeners(e.listening, !1)), [H(e, this.addEventListener.bind(this))]), e;
            }
          }, {
            key: "registerCompListeners",
            value: function (e, t, i) {
              var r = this,
                o = t ? this.settings.actionsOnMarkerClick : this.settings.actionsOnPopupClick,
                a = t ? this.settings.actionsOnMarkerMouseOver : this.settings.actionsOnPopupMouseOver,
                s = t ? this.settings.actionsOnMarkerMouseOut : this.settings.actionsOnPopupMouseOut,
                l = t ? this.settings.keyNamesForMarkerKeyPressEvent : this.settings.keyNamesForPopupKeyPressEvent,
                u = this.handleClick.bind(this),
                c = this.handleMouseOver.bind(this),
                h = this.handleMouseOut.bind(this),
                d = this.handleKeyPress.bind(this),
                p = function (e, t) {
                  n.HtmlUtils.isAnHtmlElement(e) && t.stopPropagation(), t.stop && (t.stop(), r.ignoreMapClickEvent = !0);
                };
              return [this.addEventListener(e, X, function (n) {
                p(e, n), u(i, t, o, n.type);
              }), this.addEventListener(e, ie, function (t) {
                p(e, t), d(i, l, t.code);
              }), this.addEventListener(e, J, function (n) {
                p(e, n), c(i, t, a, n.type);
              }), this.addEventListener(e, $, function (n) {
                p(e, n), h(i, t, s, n.type);
              }), H(e, this.addEventListener.bind(this))];
            }
          }, {
            key: "_createDebugMarker",
            value: function (e) {
              return this.settings.debugMarkersPosition ? {
                debug: new google.maps.Marker({
                  position: new google.maps.LatLng(e.latLng[0], e.latLng[1]),
                  map: this.realmap
                }),
                style: "opacity: 0.5"
              } : {};
            }
          }, {
            key: "clearObfuscateArea",
            value: function (e) {
              null != e && e.marker && this.clearObfuscateAreaFromMarker(e.marker);
            }
          }, {
            key: "clearObfuscateAreaFromMarker",
            value: function (e) {
              var t, n;
              null != e && null !== (t = e.obfuscateArea) && void 0 !== t && t.setMap && (null == e || null === (n = e.obfuscateArea) || void 0 === n || n.setMap(null));
              null == e || delete e.obfuscateArea;
            }
          }, {
            key: "_createObfuscatedPolygon",
            value: function (e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                n = this.getCirclePolygonData(e);
              return new google.maps.Polygon({
                paths: n,
                map: this.realmap.data.getMap(),
                clickable: t
              });
            }
          }, {
            key: "_updateObfuscateAreaStyle",
            value: function (e, t) {
              var n,
                i,
                r,
                o,
                a,
                s = w(this.settings.obfuscateStyle[e.type], e.hashKeys),
                l = s.key,
                u = s.value;
              t.setOptions({
                fillColor: null == u || null === (n = u.fill) || void 0 === n ? void 0 : n.color,
                fillOpacity: null == u || null === (i = u.fill) || void 0 === i ? void 0 : i.opacity,
                strokeColor: null == u || null === (r = u.line) || void 0 === r ? void 0 : r.color,
                strokeOpacity: null == u || null === (o = u.line) || void 0 === o ? void 0 : o.opacity,
                strokeWeight: null == u || null === (a = u.line) || void 0 === a ? void 0 : a.weight
              }), t.styleKey = l;
            }
          }, {
            key: "hasObfuscateAreaStyleChanged",
            value: function (e) {
              var t, n;
              return (null === (t = this.getMarkerComponent(e)) || void 0 === t ? void 0 : t.obfuscateArea) && (null === (n = this.getMarkerComponent(e)) || void 0 === n || null === (n = n.obfuscateArea) || void 0 === n ? void 0 : n.styleKey) !== I(this.settings.obfuscateStyle[e.type], e.hashKeys);
            }
          }, {
            key: "_getMainParent",
            value: function () {
              var e;
              return (null === (e = this.customMarkerOverlay) || void 0 === e || null === (e = e.getPanes()) || void 0 === e ? void 0 : e.overlayMouseTarget) || this.temporaryDiv;
            }
          }, {
            key: "createPinMarkerWithClickListener",
            value: function (e, t, i) {
              var r = e.feature,
                o = e.container,
                a = e.cornerIcons,
                s = e.innerIcons,
                l = e.cssClasses,
                u = e.zIndex,
                c = e.label,
                h = e.subLabel,
                d = e.ariaLabels,
                p = "none" !== i,
                g = this._createDebugMarker(r),
                f = g.debug,
                v = g.style,
                m = this.uniqId("marker-".concat(this.asKey(r))),
                y = "".concat(l.join(" ")).concat(p ? " frame-".concat(i) : ""),
                b = o || n.HtmlUtils.createDiv(m, this._getMainParent(), y, v);
              o && n.HtmlUtils.replaceClassesAndStyle(o, y, v);
              var _ = N(t, b, i, !0, oe),
                k = _.iconImg,
                L = _.main;
              b.frameIcon = i, b.compType = "pin", n.HtmlUtils.setAriaHidden(L), b.iconElements = {
                cornerIcons: a,
                innerIcons: s
              }, Z(b, a), R(k, s), n.HtmlUtils.setZIndex(b, u), b.ariaElement = b, B(r.highlighted, b.ariaElement, d), b.zIndexElement = b, b.iconElements.pin = L, b.clone = function () {
                return b.cloneNode(!0);
              }, b.bounceElement = L, b.cssElement = b, b.labels = {
                textLblCont: b
              }, K(b, r, c, h, this.settings, this._zIndexAdjustment);
              var C = p ? b : k;
              return b.listening !== C && (this.cleanMarkerListeners(b), b.listening = C, b.clean = this.registerCompListeners(b.listening, !0, r)), b.position = new google.maps.LatLng(r.latLng[0], r.latLng[1]), b.debug = f, b;
            }
          }, {
            key: "createTextMarkerWithClickListener",
            value: function (e, t, i) {
              var r = e.feature,
                o = e.container,
                a = e.cornerIcons,
                s = e.innerIcons,
                l = e.cssClasses,
                u = e.zIndex,
                c = e.label,
                h = e.subLabel,
                d = e.ariaLabels,
                p = this._createDebugMarker(r),
                g = p.debug,
                f = p.style,
                v = this.uniqId("marker-".concat(this.asKey(r))),
                m = l.join(" "),
                y = V(v, o, this._getMainParent(), i, m, t, f),
                b = y.main,
                _ = y.text,
                k = y.span;
              b.iconElements = {
                cornerIcons: a,
                innerIcons: s
              }, Z(_, a), R(k, s), n.HtmlUtils.setZIndex(b, u), b.ariaElement = _, B(r.highlighted, b.ariaElement, d), b.zIndexElement = b, b.clone = function () {
                return b.cloneNode(!0);
              }, b.bounceElement = _, b.cssElement = b, b.labels = {
                textLblCont: b
              }, b.label = t, K(b, r, c, h, this.settings, this._zIndexAdjustment.bind(this));
              var L = b;
              return b.listening !== L && (this.cleanMarkerListeners(b), b.listening = L, b.clean = this.registerCompListeners(b.listening, !0, r)), b.position = new google.maps.LatLng(r.latLng[0], r.latLng[1]), b.debug = g, b;
            }
          }, {
            key: "createClusterMarkerWithClickListener",
            value: function (e, t, i) {
              var r = this._createDebugMarker(e),
                o = r.debug,
                a = r.style,
                s = this._createClusterMarker(this._getMainParent(), e, t, i, a);
              s.clone = function () {
                return s.cloneNode(!0);
              };
              var l = O(this.settings.zIndexes[e.type], e.hashKeys);
              return n.HtmlUtils.setZIndex(s, l), s.zIndexElement = s, this.cleanMarkerListeners(s), s.listening = s, s.clean = this.registerCompListeners(s.listening, !0, e), s.position = new google.maps.LatLng(e.latLng[0], e.latLng[1]), s.debug = o, s;
            }
          }, {
            key: "createObfuscateMarkerWithClickListener",
            value: function (e) {
              var t = this,
                i = e.feature,
                r = e.container,
                o = e.cssClasses,
                a = e.zIndex,
                s = e.label,
                l = e.subLabel,
                u = e.ariaLabels,
                c = this._createDebugMarker(i),
                h = c.debug,
                d = c.style,
                p = this.uniqId("marker-".concat(this.asKey(i))),
                g = o.join(" "),
                f = r || n.HtmlUtils.createDiv(p, this._getMainParent(), g, d);
              r && n.HtmlUtils.replaceClassesAndStyle(r, g, d);
              var v = this._createObfuscatedPolygon(i, !0);
              this._updateObfuscateAreaStyle(i, v), n.HtmlUtils.setZIndex(f, a), f.ariaElement = f, B(i.highlighted, f.ariaElement, u), f.zIndexElement = f, f.cssElement = f, f.labels = {
                textLblCont: f
              }, K(f, i, s, l, this.settings, this._zIndexAdjustment);
              var m = v;
              return f.listening !== m && (this.cleanMarkerListeners(f), f.listening = m, f.clean = this.registerCompListeners(f.listening, !0, i)), f.position = new google.maps.LatLng(i.latLng[0], i.latLng[1]), f.clone = function () {
                return t.cloneObfuscatedPolygon(i, f);
              }, f.obfuscateArea = v, f.debug = h, f;
            }
          }, {
            key: "createPinObfuscateMarkerWithClickListener",
            value: function (e, t, i) {
              var r = this,
                o = e.feature,
                a = e.container,
                s = e.cornerIcons,
                l = e.innerIcons,
                u = e.cssClasses,
                c = e.zIndex,
                h = e.label,
                d = e.subLabel,
                p = e.ariaLabels,
                g = this._createDebugMarker(o),
                f = g.debug,
                v = g.style,
                m = this.uniqId("marker-".concat(this.asKey(o))),
                y = "none" !== i,
                b = "".concat(u.join(" ")).concat(y ? " frame-".concat(i) : ""),
                _ = a || n.HtmlUtils.createDiv(m, this._getMainParent(), b, v);
              a && n.HtmlUtils.replaceClassesAndStyle(a, b, v);
              var k = n.HtmlUtils.createDiv(void 0, _, "pin-marker"),
                L = n.HtmlUtils.createDiv(void 0, k, "marker-icon-inter");
              n.HtmlUtils.setAriaHidden(L);
              var C = N(t, L, i, !0, oe),
                M = C.iconImg,
                P = C.main;
              _.frameIcon = i, _.iconElements = {
                cornerIcons: s,
                innerIcons: l
              }, Z(L, s), R(M, l);
              var E = this._createObfuscatedPolygon(o);
              return this._updateObfuscateAreaStyle(o, E), n.HtmlUtils.setZIndex(k, c), _.ariaElement = k, B(o.highlighted, _.ariaElement, p), _.zIndexElement = k, _.bounceElement = P, _.cssElement = _, _.labels = {
                textLblCont: n.HtmlUtils.isAnHtmlElement(t) ? P : L
              }, _.iconElements.pin = P, _.obfuscateArea = E, _.clone = function () {
                return r.cloneObfuscatedPolygon(o, _);
              }, K(_, o, h, d, this.settings, this._zIndexAdjustment), this.cleanMarkerListeners(_), _.listening = y ? k : M, _.clean = this.registerCompListeners(_.listening, !0, o), _.position = new google.maps.LatLng(o.latLng[0], o.latLng[1]), _.debug = f, _;
            }
          }, {
            key: "createPriceObfuscateMarkerWithClickListener",
            value: function (e, t) {
              var i = this,
                r = e.feature,
                o = e.container,
                a = e.cornerIcons,
                s = e.innerIcons,
                l = e.cssClasses,
                u = e.zIndex,
                c = e.label,
                h = e.subLabel,
                d = e.ariaLabels,
                p = this._createDebugMarker(r),
                g = p.debug,
                f = p.style,
                v = this.uniqId("marker-".concat(this.asKey(r))),
                m = l.join(" "),
                y = o || n.HtmlUtils.createDiv(v, this._getMainParent(), m, f);
              o && n.HtmlUtils.replaceClassesAndStyle(o, m, f);
              var b = V(void 0, void 0, y, "price", "price-marker", t),
                _ = b.main,
                k = b.text,
                L = b.span;
              y.iconElements = {
                cornerIcons: a,
                innerIcons: s
              }, Z(k, a), R(L, s);
              var C = this._createObfuscatedPolygon(r);
              return this._updateObfuscateAreaStyle(r, C), n.HtmlUtils.setZIndex(_, u), y.ariaElement = k, B(r.highlighted, y.ariaElement, d), y.zIndexElement = _, y.bounceElement = k, y.cssElement = y, y.labels = {
                textLblCont: _
              }, this.cleanMarkerListeners(y), y.listening = _, y.clean = this.registerCompListeners(y.listening, !0, r), y.position = new google.maps.LatLng(r.latLng[0], r.latLng[1]), y.obfuscateArea = C, y.clone = function () {
                return i.cloneObfuscatedPolygon(r, y);
              }, y.label = t, K(y, r, c, h, this.settings, this._zIndexAdjustment), y.debug = g, y;
            }
          }, {
            key: "resetRouteStyle",
            value: function () {}
          }, {
            key: "_createPolyline",
            value: function (e, t, n) {
              var i = {
                path: e,
                geodesic: null != n && n
              };
              switch (t.lineStyle) {
                case "none":
                  break;
                case "dash":
                  i.icons = [{
                    icon: {
                      path: "M 0,-1 0,1",
                      fillColor: t.color,
                      fillOpacity: t.opacity,
                      strokeColor: t.color,
                      strokeOpacity: t.opacity,
                      scale: t.width
                    },
                    offset: "0",
                    repeat: "".concat(4 * t.width, "px")
                  }], i.strokeOpacity = 0;
                  break;
                case "dot":
                  i.icons = [{
                    icon: {
                      path: google.maps.SymbolPath.CIRCLE,
                      fillColor: t.color,
                      fillOpacity: t.opacity,
                      strokeColor: t.color,
                      strokeOpacity: t.opacity,
                      scale: t.width / 2
                    },
                    offset: "0",
                    repeat: "".concat(2 * t.width, "px")
                  }], i.strokeOpacity = 0;
                  break;
                default:
                  i.strokeColor = t.color, i.strokeWeight = t.width, i.strokeOpacity = t.opacity;
              }
              return new google.maps.Polyline(i);
            }
          }, {
            key: "addRouteOnMap",
            value: function (e, t) {
              var n = this;
              return new Promise(function (i) {
                var r;
                null === (r = t.route) || void 0 === r || delete r.copyrights;
                var o = "flying" == e.mode;
                e.polyline = n._createPolyline(t.route.path, n.settings.routeLineStyleByDistanceMode[e.mode], o), e.polyline.setMap(n.realmap), i(e);
              });
            }
          }, {
            key: "removeRouteOnMap",
            value: function (e) {
              return new Promise(function (t) {
                var n;
                null === (n = e.polyline) || void 0 === n || n.setMap(null), t();
              });
            }
          }, {
            key: "addPolygonsOnMap",
            value: function (e) {
              var t = this,
                n = e.map(function (e) {
                  var n = e.polygonDisplayed,
                    i = e.style,
                    r = n.id,
                    o = n.type,
                    a = n.polygon,
                    s = t._createPolygon(a, i);
                  s.forEach(function (e) {
                    return e.setMap(t.realmap);
                  });
                  var l = {
                      id: r,
                      type: o
                    },
                    u = t.asKey(l);
                  return t.visiblePolygonsByKey.set(u, s), l;
                });
              return Promise.resolve(n);
            }
          }, {
            key: "removePolygonsOnMap",
            value: function (e) {
              var t = this,
                n = e.map(function (e) {
                  var n = t.asKey(e),
                    i = t.visiblePolygonsByKey.get(n);
                  if (i) return i.forEach(function (e) {
                    return e.setMap(null);
                  }), t.visiblePolygonsByKey.delete(n), e;
                }).filter(function (e) {
                  return void 0 !== e;
                });
              return Promise.resolve(n);
            }
          }, {
            key: "_createPolygon",
            value: function (e, t) {
              return z(e).map(function (e) {
                var n = {
                  clickable: !1,
                  paths: 1 === e.length ? e[0] : e,
                  strokeColor: t.line.color,
                  strokeOpacity: t.line.opacity,
                  strokeWeight: t.line.weight,
                  fillColor: t.fill.color,
                  fillOpacity: t.fill.opacity
                };
                return new google.maps.Polygon(n);
              });
            }
          }, {
            key: "_zIndexAdjustment",
            value: function (e) {
              return google.maps.Marker.MAX_ZINDEX + e;
            }
          }, {
            key: "forceMapModeView",
            value: function () {
              var e;
              null === (e = this.realmap) || void 0 === e || null === (e = e.getStreetView()) || void 0 === e || e.setVisible(!1);
            }
          }]), i;
        }(n.BaseMap);
      ("undefined" != typeof window ? window : i.g).egmapsGoogleMaps = e;
    }(), r;
  }();
});